import * as Scrivito from "scrivito"
import { LinkListVariant } from "shared/ui/link-list/LinkList"

export const LinkListWidget = Scrivito.provideWidgetClass("LinkListWidget", {
  attributes: {
    title: "string",
    hasIcons: "boolean",
    links: "linklist",
    iconLinks: [
      "widgetlist",
      { only: ["LinkListIconLinkWidget", "LinkListActionWidget"] }
    ],
    variant: ["enum", { values: Object.values(LinkListVariant) }]
  }
})

export type LinkListWidgetInstance = InstanceType<typeof LinkListWidget>
